import { createStore, attach, createEvent, sample } from "effector";
import { $playerConfig } from "./playerConfig";
import { $playerProfile } from "./playerProfile";

export const $energyTimer = createStore(Date.now());
export const setEnergyTimer = attach({
    source: [$playerProfile, $playerConfig],
    effect: async (data) => {
        const [userProfile, playerConfig] = data;
        // console.log(Math.floor((Date.now() - userProfile.updated_energy) / 1000))
        return playerConfig.base_values.one_energy_recovery_speed_in_msec / 1000 - Math.floor((Date.now() - userProfile.updated_energy) % playerConfig.base_values.one_energy_recovery_speed_in_msec / 1000);
    }
})
setInterval(() => { setEnergyTimer() }, 1000)
$energyTimer.on(setEnergyTimer.doneData, (_, newD) => newD)

export const energyTopUp = createEvent<number>();
$playerProfile.on(energyTopUp, (state, energyAmount) => {
    state.player_wallet.currency_energy += energyAmount;
    return { ...state }
});

sample({
    source: {
        energyTimer: $energyTimer,
        config: $playerConfig
    },
    filter: ({ energyTimer, config }) => energyTimer == config.base_values.one_energy_recovery_speed_in_msec / 1000,
    fn: () => 1,
    target: energyTopUp
})